import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('poweroceanapp');
    const { locale } = useRouter();

    return (
        <div className={`ef-app-pc-d ${css.efAppPCD}`}>
            <div className="text-wrapper">
                <p className="sub-title">{t('sec4_subtitle')}</p>
                <p className="title">{t('sec4_title')}</p>
                <p className="desc">{t('sec4_desc')}</p>
            </div>
            <div className="panel-wrapper">
                <div className="panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/4-1.webp')}
                        src={require('@publicLocal/power-ocean/app/4-1.png')}
                        alt={t('sec4_title')}
                        aria-label={t('sec4_title')}
                    />
                </div>
                <div className="panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/4-2.webp')}
                        src={require('@publicLocal/power-ocean/app/4-2.png')}
                        alt={t('sec4_title')}
                        aria-label={t('sec4_title')}
                    />
                </div>
                <div className="panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/4-3.webp')}
                        src={require('@publicLocal/power-ocean/app/4-3.png')}
                        alt={t('sec4_title')}
                        aria-label={t('sec4_title')}
                    />
                </div>
            </div>
        </div>
    );
}
